import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarLocalidade from '../../components/modal/ModalCadastrarLocalidade';
import ModalEditarLocalidade from '../../components/modal/ModalEditarLocalidade';
import ModalExcluirLocalidade from '../../components/modal/ModalExcluirLocalidade';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Localidade() {
    const { Success, Error, openModal, setOpenModal, LocalidadesConsulta, ListaLocalidadeConsulta, loading, modalEditarLocalidade, setModalEditarLocalidade, setEdicaoLocalidade, setLocalidadeAtualKey, modalExcluirLocalidade, setModalExcluirLocalidade, InativarLocalidade, ListaFiltroLocalidade, totalRegistrosLocalidade, filtroLocalidade, totalRegistrosFiltroLocalidade } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditLocalidade = (props) => {
        setModalEditarLocalidade(true)
        setLocalidadeAtualKey(props.key)
        setEdicaoLocalidade(props)
    }

    const DeletarLocalidade = (props) => {
        setLocalidadeAtualKey(props.key)
        setModalExcluirLocalidade(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroLocalidade(searchTerm, currentPage, pageSize);
        } else {
            ListaLocalidadeConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroLocalidade : totalRegistrosLocalidade;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar localidades'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarLocalidade &&
                <ModalEditarLocalidade currentPage={currentPage} />
            }
            {modalExcluirLocalidade &&
                <ModalExcluirLocalidade currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarLocalidade closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar localidade</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Localidades cadastradas</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroLocalidade : LocalidadesConsulta}
                            columns={[
                                { label: "Localidade", field: "nome", width: "40%", render: (x) => x.nome || "-"  },
                                { label: "Organização", field: "descricao", width: "40%", render: (x) => x?.organizacao?.nome || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarLocalidade(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditLocalidade(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarLocalidade(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroLocalidade(term, 1, 10);
                                } else {
                                    ListaLocalidadeConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Localidade;